import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import api from "../Interceptor";
import { getRoute } from "../api/routes";
import { setProjectList } from "../slices/app";
import { useSelector, useDispatch } from "react-redux";
import useModal from "../hooks/useModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddProject from "./AddProject";

const SiderProjectList = ({ onMenuSelect }) => {
  const [isMobile, setIsMobile] = useState(false);
  const user = useSelector((state) => state.auth.user);

  const paymentStatus = localStorage.getItem("paymentStatus");
  const isUnpaid =
    paymentStatus === process.env.REACT_APP_UNPAID_SUBSCRIPTION_STATUS_ID;

  const { projectList } = useSelector((state) => state.app);
  const { isOpen, toggleModal } = useModal();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchProjects = async () => {
    try {
      const response = await api.get(
        getRoute("users", "admin", "projects", false, false, ""),
      );
      dispatch(setProjectList(response.data));
    } catch (error) {
      if (error?.isUnpaid) {
        return;
      }
      if (error.response && error.response.data) {
        toast.error(`Failed to fetch projects: ${error.response.data.message}`);
      } else {
        toast.error("An error occurred while fetching projects.");
      }
      console.error("Fetch projects error:", error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    const handleAiRefresh = () => fetchProjects();
    window.addEventListener("ai:refreshProjects", handleAiRefresh);
    return () =>
      window.removeEventListener("ai:refreshProjects", handleAiRefresh);
  }, []);

  const handleOpenProjectDetail = (id, name) => {
    navigate("/project", { state: { projectId: id, projectName: name } });
    if (onMenuSelect) onMenuSelect();
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Mobile breakpoint
    };

    handleResize(); // Check on component mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleOpen = () => toggleModal();
    window.addEventListener("openAddProjectModal", handleOpen);
    return () => window.removeEventListener("openAddProjectModal", handleOpen);
  }, [toggleModal]);

  return (
    <div className={`ms-3 ${isMobile ? "me-3" : "me-3"} mt-4 font-customFont`}>
      <div className="flex justify-between ">
        <h6 className="font-semibold text-gray-800 text-sm">PROJECTS</h6>
        {!isUnpaid && (
          <button
            className="w-5 h-5 bg-gradient-to-r from-blue-500 to-blue-600 text-white flex justify-center items-center rounded-md shadow-sm hover:shadow-md transition-all duration-300"
            onClick={() => {
              toggleModal();
              onMenuSelect?.();
            }}
          >
            <FontAwesomeIcon icon={faPlus} className="text-xs" />
          </button>
        )}
      </div>
      <div>
        {Array.isArray(projectList) && projectList.length > 0 && (
          <ul className="space-y-0 mt-1 max-h-72 overflow-y-auto scrollbar-hidden">
            {projectList.map((projectItem) => (
              <div
                key={projectItem?._id}
                className="group flex items-center px-2 py-2 rounded-lg cursor-pointer transition-all duration-300 hover:bg-gray-100"
                onClick={() =>
                  handleOpenProjectDetail(projectItem?._id, projectItem?.name)
                }
              >
                <div className="w-6 h-6 rounded-md bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center mr-3 group-hover:from-blue-200 group-hover:to-blue-300 transition-all duration-300">
                  <i className="fas fa-folder text-blue-600 text-xs"></i>
                </div>
                <span className="text-gray-700 text-sm font-medium truncate group-hover:text-blue-600 transition-colors duration-300">
                  {projectItem?.name}
                </span>
              </div>
            ))}
          </ul>
        )}
      </div>
      <AddProject
        isOpen={isOpen}
        toggleModal={toggleModal}
        fetchProjects={fetchProjects}
      />
    </div>
  );
};

export default SiderProjectList;
